import React from 'react'
import styled, { css } from 'styled-components'
import { CallSplitOutlined } from '@material-ui/icons'
import { colors } from '../../styles'

interface IPublishedIcon {
  failure?: boolean
  size?: 'small' | 'medium' | 'large'
}

export const PublishedIcon = styled(CallSplitOutlined)<IPublishedIcon>`
  ${({ failure }: IPublishedIcon) =>
    failure &&
    css`
      color: ${colors.error};
    `}
` as React.ComponentType<any>
